module.exports = {"dates":{"DateTimeFormat":"dddd Do MMM HH:mm","DateTimeFormatLong":"ddd, D MMM YYYY [at] HH:mm","TimeFormat":"HH:mm","TimeFormatLong":"HH:mm","TimeFormatMeridiem":""},"phone":{"phoneFormat":"(?:[+]|[0-9])?(?:[0-9\\s]{9,14})"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./src/locals/en-GB.json
// module id = 1687
// module chunks = 5